import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/planUsageLogAction";
import * as uiHelpers from "../PlanUsageLogUIHelpers";
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
} from "../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import {
  Pagination,
  Select,
} from "../../../../../_metronic/_partials/controls";
import moment from "moment";
import { Formik } from "formik";

const PlanUsageLogTable = () => {
  // Getting curret state of planUsageLog list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.planUsageLog }),
    shallowEqual
  );

  const [queryParams, setQueryParams] = useState(uiHelpers.initialFilter);

  const { totalCount, entities, listLoading } = currentState;

  const dispatch = useDispatch();
  useEffect(() => {
    //Requset ke Branch Action
    dispatch(actions.fetchPlanUsageLogs(queryParams));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "created_at",
      text: "Tanggal",
      formatter: (cell) => {
        return moment(cell).format("YYYY-MM-DD HH:mm:ss");
      },
    },
    {
      dataField: "action",
      text: "Action",
    },
    {
      dataField: "quota_type",
      text: "Tipe",
    },
    {
      dataField: "description",
      text: "Deskripsi",
    },
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: queryParams.pageSize,
    page: queryParams.pageNumber,
  };

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={{}}
        onSubmit={(values) => {
          setQueryParams((prevState) => ({
            ...prevState,
            filter: {
              ...prevState.filter,
              action: values.action,
              quota_type: values.quota_type,
            },
          }));
        }}
      >
        {({ handleSubmit }) => (
          <>
            <div className="form-group row">
              <div className="col-lg-4">
                <Select name="action" label="Action">
                  <option value="">--PILIH--</option>
                  {uiHelpers.usageLogAction.map((item) => (
                    <>
                      <option key={item.value} value={item.value}>
                        {item.label}
                      </option>
                    </>
                  ))}
                </Select>
              </div>
              <div className="col-lg-4">
                <Select name="quota_type" label="Tipe">
                  <option value="">--PILIH--</option>
                  {uiHelpers.usageLogQuotaType.map((item) => (
                    <>
                      <option key={item.value} value={item.value}>
                        {item.label}
                      </option>
                    </>
                  ))}
                </Select>
              </div>
            </div>
            <div>
              <button
                className="btn btn-warning float-right"
                onClick={handleSubmit}
              >
                Terapkan
              </button>
            </div>
          </>
        )}
      </Formik>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                remote
                keyField="uuid"
                data={entities === null ? [] : entities}
                columns={columns}
                // defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(setQueryParams)}
                // selectRow={getSelectRow({
                //   entities,
                //   ids: productsUIProps.ids,
                //   setIds: productsUIProps.setIds,
                // })}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
};

export default PlanUsageLogTable;
